import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-125f2788"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-grow-0 flex-shrink-0" }
const _hoisted_2 = {
  key: 0,
  class: "mx-2 flex-grow-1 li-fill"
}
const _hoisted_3 = { key: 0 }

import TooltipIcon from '@/components/tooltip/TooltipIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FilledListItem',
  props: {
    caption: null,
    tooltip: null,
    data: null,
    notFilled: { type: Boolean },
    color: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex flex-wrap", __props.notFilled ? 'not-filled-list-item' : 'filled-list-item'])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", {
        class: _normalizeClass(`caption text-${__props.color}`)
      }, _toDisplayString(__props.caption), 3),
      (__props.tooltip)
        ? (_openBlock(), _createBlock(TooltipIcon, {
            key: 0,
            tooltip: __props.tooltip,
            inline: "",
            color: __props.color
          }, null, 8, ["tooltip", "color"]))
        : _createCommentVNode("", true)
    ]),
    (!__props.notFilled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["flex text-sm li-data", __props.notFilled ? '' : ''])
    }, [
      (__props.data)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(__props.data), 1))
        : _renderSlot(_ctx.$slots, "data", { key: 1 })
    ], 2)
  ], 2))
}
}

})